import {
  type ComponentType as ReactComponentType,
  forwardRef,
  type ForwardRefExoticComponent,
} from 'react';

type ContainerComponentProps<Props> = Omit<
  Props,
  'dangerouslyOverrideClassName'
> & {
  className?: string;
};

export function withClassNameHoc<
  P extends {
    dangerouslyOverrideClassName?: { __className?: string };
  },
>(Component: ReactComponentType<P> | ForwardRefExoticComponent<P>) {
  const hoc = forwardRef<unknown, ContainerComponentProps<P>>((props, ref) => {
    const { className, ...remaining } = props as ContainerComponentProps<P>;
    const rest = remaining as P;

    if (className) {
      rest.dangerouslyOverrideClassName = {
        __className: className,
      };
    }

    return <Component ref={ref} {...rest} />;
  });

  hoc.displayName = `withClassNameHoc(${Component.displayName || Component.name || 'Component'})`;

  return hoc;
}
